<script>
export const pageName = 'inventory-motors-usage';
export const pageRoute = '/inventory/motors/usage/{year}';
export const title = 'Motor Inventory Usage'
export const requireMembership = true;

import { getCurrentUserId } from '../../js/auth.js'
import { listenToMotorsInventory } from '../../js/readModel.js';
import { impulseToClass } from '../../../functions/domain/certification-utils.js';
import { listInventoryHistoryYears } from '../../../functions/domain/inventory/motorUtils.js';

export default {
	data() {
		return { 
			inventory: null,
			motors: [],
			sortOrder: '',
			sortKey: '',
			years: ['2026', '2025'],
			year: '2026',
			ready: false
		}
	},

	methods: {
		impulseToClass,
		async boot(opts) {

			await listenToMotorsInventory(getCurrentUserId(), opts.year, inventory => {
				this.inventory = inventory;
				this.motors = [...this.inventory.motors]
				this.sort('designation')
			});
			
			this.years = listInventoryHistoryYears()
			this.year = opts.year

			this.ready = true;
		},
		sort(sortKey, sortOrder)
		{
			if(sortKey != this.sortKey)
			{
				this.sortKey = sortKey
				this.sortOrder = sortOrder || 'asc'
			}
			else if(this.sortOrder == 'asc')
				this.sortOrder = 'desc'
			else
				this.sortOrder = 'asc'
			
			this.doSort();
		},
		doSort()
		{
			switch(this.sortKey)
			{
				case 'classification':
					this.motors.sort((a, b) => (this.sortOrder == 'asc' ? a : b).classification.localeCompare((this.sortOrder == 'asc' ? b : a).classification));
					break;
				case 'manufacturer':
					this.motors.sort((a, b) => (this.sortOrder == 'asc' ? a : b).manufacturer.localeCompare((this.sortOrder == 'asc' ? b : a).manufacturer));
					break;
				case 'designation':
					this.motors.sort((a, b) => (this.sortOrder == 'asc' ? a : b).designation.localeCompare((this.sortOrder == 'asc' ? b : a).designation, 'en', { numeric: true }));
					break;
				case 'propType':
					this.motors.sort((a, b) => ((this.sortOrder == 'asc' ? a : b).propType || '').localeCompare((this.sortOrder == 'asc' ? b : a).propType || ''));
					break;
				case 'notes':
					this.motors.sort((a, b) => ((this.sortOrder == 'asc' ? a : b).notes || '').localeCompare((this.sortOrder == 'asc' ? b : a).notes || ''));
					break;
				case 'quantity':
					this.motors.sort((a, b) => (this.sortOrder == 'asc' ? a : b).quantity - (this.sortOrder == 'asc' ? b : a).quantity);
					break;
			}
		}
	}
}

</script>
<template>
	<div v-if="ready" class="container py-5">
		<div class="row justify-content-center">
			<div class="col-12 col-md-6 mt-5">
				<h1 class="display-4 text-center mb-3">Motor Inventory</h1>
				<p class="text-muted text-center mb-3">Keep track of whats in your inventory for stock keeping purposes.</p>
				<p class="text-muted text-center mb-5">Using inventory motors in your flight logs will automatically adjust the stock levels and keep a track of how much propellant you've burned.</p>
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="col-12 col-md-10 mb-5">
				<div class="header">
					<div class="header-body">
						<div class="row align-items-end">
							<div class="col">
								<h6 class="header-pretitle">Motor inventory</h6>
								<h1 class="header-title">{{year}} Usage</h1>
							</div>
							<div class="col-auto">
								<ul class="nav nav-tabs header-tabs">
									<li class="nav-item">
										<a href="/inventory/motors" class="nav-link text-center">Current stock</a>
									</li>
									<li v-for="y of years" class="nav-item">
										<a :href="`/inventory/motors/usage/${y}`" :class="`nav-link text-center ${year == y ? 'active' : ''}`">{{y}}</a>
									</li>
								</ul>
							</div>
						</div> 
					</div>
				</div>
				<div class="row text-center my-5">
					<div class="col">
						<div class="text-muted display-4">{{ inventory.totalPropWeight }}g</div>
						<div class="small">Burned</div>
					</div>
					
					<div class="col">
						<div class="text-muted display-4">{{ Math.ceil(inventory.totalImpulse) }}Ns</div>
						<div class="small">Impulse</div>
					</div>
					<div class="col">
						<div class="text-muted display-4">{{ impulseToClass(inventory.totalImpulse) }}</div>
						<div class="small">Classification</div>
					</div>
				</div>
			

				<div class="card">
					<table class="table card-table">
						<thead>
							<tr>
								<th class="sort" @click="sort('classification')">Class</th>
								<th class="sort" @click="sort('manufacturer')">Mfr.</th>
								<th class="sort" @click="sort('designation')">Motor</th>
								<th class="sort" @click="sort('propType')">Prop.</th>
								<th class="sort" @click="sort('quantity', 'desc')">Qty</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="motor in motors">
								<td>{{ motor.classification }}</td>
								<td>{{ motor.manufacturer }}</td>
								<td>{{ motor.designation }}</td>
								<td>{{ motor.propType }}</td>
								<td class="shrink text-center">{{ motor.quantity }}</td>
							</tr>
						</tbody>
					</table>
					
					<div v-if="motors.length == 0" class="card-body">
						<p class="text-muted mb-0 text-center">You do not have any motors usage this year.</p>
					</div>
				</div>
				<div v-if="year == 2025" class="">
					<p class="small text-muted text-center mb-0"><span class="fe fe-info"></span> Only flights recorded after 1st August 2025 are included.</p>
				</div>
			</div>
		</div>
    </div>
</template>
